import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAppSelector } from '../store/configureStore';

import { UserRoles } from '../utils/userRoles';
import { getUserRoles } from '../data/auth/roles';

interface Props {
  roles?: UserRoles[];
}

export default function RequireAuth({ roles }: Props) {
  const { user } = useAppSelector((state) => state.account);
  const location = useLocation();

  if (!user) {
    return <Navigate to="/account/login" state={{ from: location }} />;
  }

  console.log('User roles:', user.roles);
  console.log('Required roles:', roles);
  console.log('User roles from getUserRoles:', getUserRoles(user.roles));

  if (roles && !roles.some((r) => getUserRoles(user.roles).includes(r))) {
    return <Navigate to="/forbidden" />;
  }

  return <Outlet />;
}
